/**
 * Return the message to show for a failed path service request made through
 * RTK Query.
 *
 * The Django proxy keeps the path service's error body: `detail` for missing
 * states, missing scenarios, and some invalid requests, or `error` for other
 * invalid requests. A request that did not complete has `error` on the error
 * itself. Falls back to `Request failed.` when none of these is a string.
 */
export const pathServiceErrorMessage = (error: unknown): string => {
  if (typeof error !== 'object' || error === null) return 'Request failed.';
  if (
    'data' in error &&
    typeof error.data === 'object' &&
    error.data !== null
  ) {
    if ('detail' in error.data && typeof error.data.detail === 'string') {
      return error.data.detail;
    }
    if ('error' in error.data && typeof error.data.error === 'string') {
      return error.data.error;
    }
  }
  if ('error' in error && typeof error.error === 'string') return error.error;
  if ('message' in error && typeof error.message === 'string') {
    return error.message;
  }
  return 'Request failed.';
};
